import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export function TermsGate() {
  const { user, refresh, logout } = useAuth();
  const { pathname } = useLocation();
  const nav = useNavigate();
  const [ok, setOk] = useState(false);
  const [busy, setBusy] = useState(false);
  if (!user?.terms_required || pathname.startsWith("/legal")) return null;
  const pro = user.role === "provider";

  const accept = async () => {
    setBusy(true);
    try {
      await api.post("/auth/accept-terms", { accept: true });
      await refresh();
      toast.success("Thanks, you're all set");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[100] bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4" data-testid="terms-gate">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-6 sm:p-8 fade-up">
        <ShieldCheck className="w-9 h-9 text-[#FF8166]" />
        <h2 className="text-xl font-bold text-slate-900 mt-3">We've updated our terms</h2>
        <p className="text-sm text-slate-600 mt-2">Please read and accept the latest terms to continue using your account.</p>
        <div className="mt-4 flex flex-col gap-1 text-sm">
          <Link to={pro ? "/legal/service-provider-terms" : "/legal/terms"} target="_blank" className="underline font-medium" data-testid="terms-gate-terms-link">{pro ? "Service Provider Terms & Conditions" : "General Terms & Conditions"}</Link>
          <Link to="/legal/privacy-policy" target="_blank" className="underline" data-testid="terms-gate-privacy-link">Privacy Policy</Link>
        </div>
        <label className="flex gap-2 text-sm mt-5"><input type="checkbox" checked={ok} onChange={(e) => setOk(e.target.checked)} data-testid="terms-gate-checkbox" />
          <span>I confirm I have read and agree to the {pro ? "Service Provider Terms & Conditions" : "General Terms & Conditions"} and Privacy Policy</span></label>
        <button className="btn-coral w-full mt-5" disabled={!ok || busy} onClick={accept} data-testid="terms-gate-accept">{busy ? "Saving…" : "Accept and continue"}</button>
        <button className="w-full mt-3 text-sm text-slate-500 underline" onClick={async () => { nav("/"); await logout(); }} data-testid="terms-gate-logout">Log out</button>
      </div>
    </div>
  );
}
